import bookingApi from '@/api/booking'
import Vue from 'vue'

const commitMethodByType = {
    'transporter': 'SET_TRANSPORTER_COMPANIES',
    'client': 'SET_CLIENT_COMPANIES',
    'responsible': 'SET_RESPONSIBLE_CONTACTS'
};

const defaultState = () => ({
    booking: [],
    transporterCompanies: [],
    clientCompanies: [],
    responsibleContacts: [],
    bookKeepingContacts: [],
    allTableFields: [],
    localizedFields: [],
    transportationTypes: [
        {id: 1, name: 'По украине'},
        {id: 2, name: 'Международная'}
    ],
    isBusyTable: false,
    additionalData: {
        per_page: 30,
        page: 1,
        total: 0,
        last_page: 0,
        sortBy: null,
        sortDesc: false
    }
})

const INDEX_MODULE = {
    namespaced: true,
    state: defaultState(),
    getters: {
        getLocalPayload: (state) => {
            const args = {
                'page-limit': state.additionalData.per_page || 30,
                page: state.additionalData.page || 1
            }

            if (state.additionalData.sortBy) {
                args[`sorting[${state.additionalData.sortBy}]`] = !state.additionalData.sortDesc ? 'asc' : 'desc'
            }

            return args
        },
        getTransporterCompanies: (state) => state.transporterCompanies,
        getClientCompanies: (state) => state.clientCompanies,
        getBookingContacts: (state) => state.bookKeepingContacts,
        getResponsibleContacts: (state) => state.responsibleContacts,
        getTransportationTypes: (state) => state.transportationTypes
    },
    mutations: {
        MUTATION_SET_BOOKING(state, booking) {
            state.booking = booking
        },
        SET_ALL_TABLE_FIELDS(state, fields) {
            state.allTableFields = fields
        },
        SET_TRANSPORTER_COMPANIES(state, data) {
            state.transporterCompanies = data.companies
        },
        SET_CLIENT_COMPANIES(state, data) {
            state.clientCompanies = data.companies
        },
        SET_RESPONSIBLE_CONTACTS(state, data) {
            state.responsibleContacts = data.contacts
        },
        SET_TABLE_LOCALIZED_FIELDS(state, fields) {
            state.localizedFields = fields
        },
        UPDATE_BUSY_TABLE(state, value = false) {
            state.isBusyTable = value
        },
        SET_TABLE_PAGE(state, page) {
            state.additionalData.page = page
        },
        SET_PAGE_LIMIT(state, limit) {
            state.additionalData.per_page = limit
        },
        SET_ADDITIONAL_DATA(state, data) {
            state.additionalData = data
        },
        SET_TABLE_FIELDS(state, data) {
            state.allTableFields = data
        },
        SET_SORT_DATA(state, {sortBy, sortDesc}) {
            Vue.set(state.additionalData, 'sortBy', sortBy)
            Vue.set(state.additionalData, 'sortDesc', sortDesc)
        }
    },
    actions: {
        async GET_BOOKING(
            {
                commit,
                rootGetters,
                getters,
                state
            }) {
            commit('UPDATE_BUSY_TABLE', true)

            const payloadForFilter = {
                ...rootGetters['GET_BOOKING/filter/getBookingFilterPayload'],
                ...getters.getLocalPayload
            }

            try {
                let response = await bookingApi.getBookingData(payloadForFilter)
                let {
                    data,
                    localization
                } = response

                commit('MUTATION_SET_BOOKING', data.data)
                commit('SET_TABLE_LOCALIZED_FIELDS', localization)
                commit('SET_TABLE_FIELDS', Object.keys(localization))

                commit('SET_ADDITIONAL_DATA', {
                    from: data.from,
                    to: data.to,
                    last_page: data.last_page,
                    per_page: data.per_page,
                    total: data.total,
                    page: data.current_page,
                    sortBy: state.additionalData.sortBy || null,
                    sortDesc: state.additionalData.sortDesc || null
                })
            } catch (e) {
                console.error(e)
                this._vm.$notify({
                    type: 'error',
                    text: 'Ошибка получения компаний!'
                })
            } finally {
                commit('UPDATE_BUSY_TABLE', false)
            }
        },
        async fetchBookingData({commit}, datum) {
            try {
                const {data} = await bookingApi.getBookKeepingData(datum)

                commit(commitMethodByType[datum.methodType], data)
            } catch (e) {
                console.log(e)
            }
        },
        async sendForm({}, {form, onCloseModal}) {
            try {
                await bookingApi.createAct(form)

                onCloseModal()
            } catch (e) {
                console.error(e)
            }
        },
        setDefaultState({commit}) {
            commit('SET_TRANSPORTER_COMPANIES', [])
            commit('SET_CLIENT_COMPANIES', [])
        }
    }
}

export default INDEX_MODULE
